<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/japcommon">日语资源管理</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>日语资源跟进</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={};">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>资源跟进列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="japName" label="姓名"></el-table-column>
          <el-table-column prop="summary" label="跟进情况"></el-table-column>
          <el-table-column prop="japState" label="跟进阶段"></el-table-column>
          <el-table-column label="资源状态">
            <template slot-scope="scope">
              <el-tag type="info" v-if="scope.row.state==1">{{scope.row.stateName}}</el-tag>
              <el-tag type="info" v-else-if="scope.row.state==2">{{scope.row.stateName}}</el-tag>
              <el-tag type="info" v-else>{{scope.row.stateName}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="nextDate" label="下次回访时间"></el-table-column>
          <!-- <el-table-column prop="nextSubject" label="下次回访主题"></el-table-column> -->
          <!-- 操作 -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑资源跟进':'添加资源跟进'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-form-item prop="summary" label="跟进情况" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="form.summary" placeholder="请输入跟进情况"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="跟进阶段" prop="japState" :rules="[{required:true,message:'请输入跟进阶段'}]">
              <el-select v-model="form.japState" placeholder="请选择跟进阶段" filterable>
                <el-option
                  v-for="item in stustatelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="回访时间" prop="nextDate">
          <el-date-picker
            v-model="form.nextDate"
            value-format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择下次回访时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="回访主题" prop="nextSubject">
          <el-input v-model="form.nextSubject" placeholder="请输入下次回访主题"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      japid: 0,
      query: {},
      form: {},
      submiting: false,
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      stustatelist: [
        { id: "a", name: "a" },
        { id: "b", name: "b" },
        { id: "c", name: "c" },
        { id: "d", name: "d" },
        { id: "e", name: "e" }
      ] //跟进阶段
    };
  },
  methods: {
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //   排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      params.japid = _this.japid;
      var link = url.getJap("getlist_follow");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getJap("delete_follow");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.submiting = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var info = Object.assign({}, _this.form); // 创建副本
      var link = url.getJap("addorupdate_follow");
      
      // 确保字段名正确映射
      // JapID 现在应该是 StudentID（Crm_Japanese 的主键）
      info.JapID = this.japid;
      // 日语状态为字符串，与后端 Crm_Student.JpStatus / Crm_JapFollow.JapState 一致
      info.JapState = info.japState != null && info.japState !== '' ? String(info.japState) : '';
      
      console.info("提交数据:", info);
      this.$refs.form.validate(valid => {
        if (valid) {
          // 验证必填字段
          if (!info.JapID || info.JapID <= 0) {
            _this.$message({
              type: "error",
              message: "资源ID无效，请刷新页面重试"
            });
            return false;
          }
          if (!info.JapState) {
            _this.$message({
              type: "error",
              message: "请选择跟进阶段"
            });
            return false;
          }
          
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.form = {}; // 重置表单
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg || "保存失败，请检查数据后重试"
              });
            }
          }).fail(function(xhr, status, error) {
            _this.submiting = false;
            _this.$message({
              type: "error",
              message: "网络错误：" + error
            });
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    var _this = this;
    //   接收参数
    _this.japid = this.$route.query.id;
    if (this.japid > 0) {
      this.getList();
    } else {
      _this.form = {};
    }
    // 列表
    _this.getList();
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>